declare global {
    interface Window {
        _env_?: Record<string, string>;
    }
}

export const getEnv = (key: string): string => {
    // 1. Check the runtime Vault window object first (Staging/Production inside Kubernetes)
    if (window._env_ && window._env_[key] !== undefined) {
        return window._env_[key];
    }
    // 2. Fall back to standard compile-time variables (Local Development via .env file)
    return process.env[key] || '';
};
